module.exports = __webpack_public_path__ + "img/17n.aa1ec342.png";